import React, {Component} from "react";
import { observer } from "mobx-react";
import {comma} from "../../../../../utils/Utils";
import OrderMenuSideDetailView from "./OrderMenuSideDetailView";
import {fn_currSetMenuCode} from "../../../../../function/FnBodyMenu";

@observer
class OrderMenuDetailView extends Component {

    constructor(props){
        super(props);
        this.state = {isToggleOn:false};
        this.fn_layerView = this.fn_layerView.bind(this);
        this.fn_soldOutLayer = this.props.fn_soldOutLayer.bind(this);
    }

    fn_layerView(){
        this.setState(layerState =>({
            isToggleOn: !layerState.isToggleOn
        }));
    }

    componentWillUnmount() {
        const { rootStore } = this.props;
        fn_currSetMenuCode(rootStore, "", null)
    }

    render() {

        const { rootStore } = this.props;
        const menuDetail = rootStore.menuStore.getMenuDetail;
        this.state.menuSoldOut = (rootStore.menuStore.getMenuDetail.soldOut === "Y")?false:true;
        return (
            <div className="section_list_view">
                <h4>상품 상세</h4>
                <div className="scroll">
                    <div className="inner">
                        <div className="wrap_menu_detail">
                            <div className="box_tit">
                                <h5>{menuDetail.prodNm}</h5>
                                <p className="pay">{comma(menuDetail.saleUprc.toString())}원</p>
                            </div>
                            <div className="box_status">
                                <strong className="tit">상품 판매 상태</strong>
                                <label className="lab_check">
                                    <input type="checkbox" id={menuDetail.prodCd} checked={this.state.menuSoldOut} onChange={this.fn_soldOutLayer}/>
                                    <span></span>
                                </label>
                            </div>
                            {(menuDetail.connProdNm != null && menuDetail.connProdNm != "")?
                            <dl className={this.state.isToggleOn ? 'info on' : 'info'} onClick={this.fn_layerView}>
                                <dt>
                                    <button><strong>연결메뉴</strong><span>상품 수정사항이 다음 메뉴에 동시에 적용됩니다.</span>
                                    </button>
                                </dt>
                                <dd>{menuDetail.connProdNm}</dd>
                            </dl>
                            :null}
                        </div>
                        {(Array.isArray(menuDetail.sdsList) && menuDetail.sdsList.length)
                            ?
                            <OrderMenuSideDetailView rootStore={rootStore} fn_soldOutLayer={this.fn_soldOutLayer}/> : null
                        }
                    </div>
                </div>
                <div className="btn_close">
                    <button type="button" onClick={event=>{fn_currSetMenuCode(rootStore, "")}}><span>닫기</span></button>
                </div>
            </div>
        );
    }
}

export default OrderMenuDetailView;